import { render } from "./SuccessfullPayment.vue?vue&type=template&id=61d303a3"
import script from "./SuccessfullPayment.vue?vue&type=script&lang=js"
export * from "./SuccessfullPayment.vue?vue&type=script&lang=js"

import exportComponent from "/home/smartphone/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__